<script setup lang="ts">
import { nextTick, ref } from 'vue'

defineOptions({ name: 'CreditSearchResultSection' })

const props = defineProps<{
  section: 'course' | 'subject'
  title: string
  count: number
}>()

const emit = defineEmits<{
  opened: [section: 'course' | 'subject']
}>()

const isOpen = ref(false)

function toggle(): void {
  isOpen.value = !isOpen.value
  if (isOpen.value) {
    nextTick(() => emit('opened', props.section))
  }
}
</script>

<template>
  <div class="accordion-item">
    <h2 class="accordion-header" :id="section === 'course' ? 'headingOne' : 'headingTwo'">
      <button
        :id="section === 'course' ? 'courseListHeaderBtn' : 'subjectListHeaderBtn'"
        class="accordion-button"
        :class="{ collapsed: !isOpen }"
        type="button"
        :aria-controls="section === 'course' ? 'collapseOne' : 'collapseTwo'"
        :aria-expanded="isOpen"
        @click="toggle"
      >
        <span class="accordion-title">{{ title }}</span>
        <span class="accordion-count">{{ count ? `- ${count} results` : '' }}</span>
      </button>
    </h2>
    <div
      :id="section === 'course' ? 'collapseOne' : 'collapseTwo'"
      class="accordion-collapse collapse"
      :class="{ show: isOpen }"
      role="region"
      :aria-labelledby="section === 'course' ? 'headingOne' : 'headingTwo'"
    >
      <div class="accordion-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.collapse:not(.show) {
  display: none;
}

.accordion-item + .accordion-item {
  margin-top: 1rem;
}
</style>
